import React from 'react';
import ReactDOM from 'react-dom/client'; // ✅ use 'react-dom/client'
import App from './App';
import "@shopify/polaris/build/esm/styles.css";



// ✅ NEW way with React 18+
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);